import React from 'react';
import { Link } from 'react-router-dom';
import control1 from '../../assets/control1.jpeg';
import control2 from '../../assets/control2.jpeg';
import control3 from '../../assets/control3.jpeg';

const ControlPanel = () => {
  return (
    <div className="w-full">
      {/* Hero Section */}
      <div className="w-full h-[400px] md:h-[300px] flex flex-col justify-center px-6 hero-bg-color">
        <h1 className="text-white text-4xl md:text-5xl font-bold">Control Panel</h1>
        <div className="text-white mt-2 text-lg">
          <Link to="/" className="underline hover:text-gray-200">Home</Link> / Control Panel
        </div>
      </div>

      {/* Page Content */}
      <div className="max-w-7xl mx-auto py-10 px-6">
        <hr className="border-gray-300/30 mb-10" />
        <div className="space-y-8">
          <div>
            <h2 className="text-3xl font-bold text-slate-900 mb-4">Control Panel Gallery</h2>
            <p className="text-gray-600 max-w-3xl">
              View our control panel installations with smart interfaces, modern finishes, and engineered reliability.
            </p>
          </div>

          <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {[
              { src: control1, alt: 'Control Panel 1' },
              { src: control2, alt: 'Control Panel 2' },
              { src: control3, alt: 'Control Panel 3' },
            ].map((image, index) => (
              <div key={index} className="overflow-hidden rounded-3xl shadow-lg bg-white h-[440px]">
                <img src={image.src} alt={image.alt} className="w-full h-full object-cover" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ControlPanel;
